import React, { useState, useEffect } from 'react';

function CaseItems({ datas }) {


    return (

        <div className="case-opening-content-box-skin">
            {datas.map((data) => {
                return (
                    <div key={data.id} className="case-opening-content-box-skin-preview">
                        <div className="case-opening-content-box-skin-preview-text">
                            <span>Gains {data.droppercentage}%</span>
                            <i className="fa-solid fa-circle-info"></i>
                        </div>
                        <img src={data.picture} alt="Img Case"
                             className="case-opening-content-box-skin-preview-img"/>
                        <span className="case-opening-content-box-skin-preview-weapon-name">{data.weaponname}</span>
                        <span className="case-opening-content-box-skin-preview-skin-name">{data.skinname}</span>
                    </div>
                )
            })}
        </div>
    );
}

export default CaseItems;